import { combineReducers } from 'redux';
import {FETCH_LOCATION_MAPS, SHOW_LOCATION_MAP_MODAL, LOCATION_MAP} from 'LocationMapActions';

export function locationMapReducers(state = [], action) {
  switch (action.type) {
    case FETCH_LOCATION_MAPS:
      return action.payload;
    default:
      return state;
  }
}

export function ShowLocationMapModal (state = false, action) {
  if (action.type === SHOW_LOCATION_MAP_MODAL) {
    return action.payload;
  }
  return state;
}

export function InitialLocationMap (state = {}, action) {
  if (action.type === LOCATION_MAP) {
    return action.payload;
  }
  return state;
}
